
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.055 10.281h2.82c.349 0 .607-.031.773-.094.172-.067.313-.169.422-.304.11-.14.209-.336.297-.586.089-.25.196-.638.32-1.164h.766V11H.234v-.383l5.352-9.562H2.75c-.203 0-.365.018-.484.054a.882.882 0 00-.313.157c-.094.067-.187.169-.281.304-.089.136-.18.323-.274.563-.088.234-.182.528-.28.883H.351V.336h7.046V.71l-5.343 9.57z","fill":"currentColor"}})])
          )
        }
      }
    